// extracted by mini-css-extract-plugin
export default {"wrap":"PartnerGameList_wrap__OOULb","grid":"PartnerGameList_grid__icx0o"};